module.exports = __webpack_public_path__ + "montserrat-regular-webfont.6fedfc64a7bfbbb272c4.svg";


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.svg
// module id = ../../../../@okta/okta-signin-widget/dist/font/montserrat-regular-webfont.svg
// module chunks = 11